<template>
    <div>
        <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options"/>
        <basic-table
            v-if="voluntarySuspensions"
            :items="voluntarySuspensions"
            :fields="fields"
            @ClickOnDeleteButton="ClickOnDeleteButton"
            :filter="filter"
            :perPage="perPage"
            :currentPage="currentPage"
            v-model="totalRows"
            :isDelete="true"
            :isEdit="false"/>
        <table-manager-bottom
            :totalRows="totalRows" :perPage="perPage"
            v-model="currentPage"/>
    </div>
</template>

<script>

export default {
  data () {
    return {
      fields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'block_date_start', label: this.$i18n.t('Start date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'block_date_end', label: this.$i18n.t('End date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'block_id', label: this.$i18n.t('Block ID'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedVoluntarySuspensionSetting: null,
      options: {
        isShowAddButton: false
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', 'Are you sure you want to delete one of "Voluntary suspension?"', this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_VOLUNTARY_SUSPENSION', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_VOLUNTARY_SUSPENSIONS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    voluntarySuspensions () {
      return this.$store.getters['Settings/ALL_VOLUNTARY_SUSPENSIONS']
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_VOLUNTARY_SUSPENSIONS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/voluntarySuspension/allSuspensions.vue